// extracted by mini-css-extract-plugin
export var EntertainmentBannerWrap = "index-module--EntertainmentBannerWrap--P1wyy";
export var greenFont = "index-module--greenFont--8r+4j";